import React, { useState } from 'react';
import './squad.css';
import { Spinner } from "react-bootstrap";
import { useDataContext } from "../context/datacontext";

const SquadAverages = ({ mySquad }) => {
  if (!mySquad || mySquad.length === 0) return null;

  const attributes = [
    "csr", "age", "weight", "height", "aggression", "discipline",
    "form", "experience", "stamina", "handling", "attack", "defense",
    "strength", "technique", "jumping", "speed", "agility", "kicking"
  ];

  return (
    <div className="averages-card">
      <h2>Averages</h2>
      {attributes.map(attr => {
        const avg = mySquad.reduce((acc, player) => acc + parseFloat(player[attr]), 0) / mySquad.length;
        return (
          <div className='average-attribute' key={attr}>
            <div className='label'>{attr.charAt(0).toUpperCase() + attr.slice(1)}:</div>
            <div className='value'>{Number(avg).toFixed(2)}</div>
          </div>
        );
      })}
    </div>
  );
}

const SquadStats = ({ title, playerIndexes, mySquad }) => {
  if (!playerIndexes || playerIndexes.length === 0) return null;

  const players = playerIndexes.map(playerId => mySquad.find(player => player.id === playerId)).filter(Boolean);

  const attributes = ["age", "csr", "form", "experience", "aggression", "discipline"];

  return (
    <div className="averages-card">
      <h2>{title}</h2>
      {attributes.map(attr => {
        const avg = players.reduce((acc, player) => acc + parseFloat(player[attr]), 0) / players.length;
        return (
          <div className='average-attribute' key={attr}>
            <div className='label'>{attr.charAt(0).toUpperCase() + attr.slice(1)}:</div>
            <div className='value'>{Number(avg).toFixed(2)}</div>
          </div>
        );
      })}
    </div>
  );
};

const Squad = () => {
  const { mySquad } = useDataContext();
  const [selectedPlayers, setSelectedPlayers] = useState(new Array(22).fill(null));

  const handleSelectChange = (index, playerId) => {
    const newSelectedPlayers = [...selectedPlayers];
    
    // check if player is already selected
    const swapIndex = newSelectedPlayers.indexOf(playerId);
    if(swapIndex !== -1) {
      // swap players
      const swappedPlayerId = newSelectedPlayers[index];
      newSelectedPlayers[swapIndex] = swappedPlayerId;
    }

    newSelectedPlayers[index] = playerId;
    setSelectedPlayers(newSelectedPlayers);
  };

  const statsData = [
    { title: "Starting Lineup", range: [0, 15] },
    { title: "Front Row", range: [0, 3] },
    { title: "Tight 5", range: [0, 5] },
    { title: 'Locks', range: [4, 5]},
    { title: "Back Row", range: [5, 8] },
    { title: "Forwards", range: [0, 8] },
    { title: "Halves", range: [8, 10] },
    { title: "Centers", range: [11, 13] },
    { title: "Outside Backs", range: [10, 14, 15] },
    { title: "Backline", range: [8, 15] },
    { title: "Bench", range: [15, 22] }
  ].map(({ title, range }) => ({
    title,
    playerIndexes: Array.from({length: range[1] - range[0]}, (_, i) => i + range[0])
  }));

  return (
    <div className='squad-container'>
      <h1>Squad</h1>
      {mySquad.map((player) => {
        return (
          <div className='player-card' key={player.id}>
            <h2 className='name'>{player.name}</h2>
            <div className='top-info'>
              <div className="row">
                <div className='attribute'><div className='label'>Weight:</div><div className='value'>{player.weight+ 'Kg'}</div></div>
                <div className='attribute'><div className='label'>Height:</div><div className='value'>{player.height + 'cm'}</div></div>
              </div>
              <div className='attribute'><div className='label'>CSR:</div><div className='value'>{player.csr}</div></div>
              <div className="row">
                <div className='attribute'><div className='label'>Aggression:</div><div className='value'>{player.aggression}</div></div>
                <div className='attribute'><div className='label'>Discipline:</div><div className='value'>{player.discipline}</div></div>
              </div>
              <div className="row">
                <div className='attribute'><div className='label'>Form:</div><div className='value'>{player.form}</div></div>
                <div className='attribute'><div className='label'>Experience:</div><div className='value'>{player.experience}</div></div>
              </div>
            </div>
            <div className='attributes'>
              <div className='column'>
                <div className='attribute'><div className='label'>Stamina:</div><div className='value'>{player.stamina}</div></div>
                <div className='attribute'><div className='label'>Attack:</div><div className='value'>{player.attack}</div></div>
                <div className='attribute'><div className='label'>Technique:</div><div className='value'>{player.technique}</div></div>
                <div className='attribute'><div className='label'>Jumping:</div><div className='value'>{player.jumping}</div></div>
                <div className='attribute'><div className='label'>Agility:</div><div className='value'>{player.agility}</div></div>
              </div>
              <div className='column'>
                <div className='attribute'><div className='label'>Handling:</div><div className='value'>{player.handling}</div></div>
                <div className='attribute'><div className='label'>Defense:</div><div className='value'>{player.defense}</div></div>
                <div className='attribute'><div className='label'>Strength:</div><div className='value'>{player.strength}</div></div>
                <div className='attribute'><div className='label'>Speed:</div><div className='value'>{player.speed}</div></div>
                <div className='attribute'><div className='label'>Kicking:</div><div className='value'>{player.kicking}</div></div>
              </div>
            </div>
          </div>
     
          
        );
      })}
      <SquadAverages mySquad={mySquad} />

      {Array.from({ length: 22 }, (_, i) => (
        <div key={i}>
          <label>Position {i+1}: </label>
          <select value={selectedPlayers[i] || ""} onChange={e => handleSelectChange(i, e.target.value)}>
            <option value="" disabled>Select player</option>
            {mySquad.map(player => (
              <option key={player.id} value={player.id}>
                {player.name}
              </option>
            ))}
          </select>
        </div>
      ))}

      {statsData.map(({ title, playerIndexes }) => (
        <SquadStats title={title} playerIndexes={playerIndexes.map(index => selectedPlayers[index]).filter(Boolean)} mySquad={mySquad} />
      ))}
    </div>
  );
};

export default Squad;